export default __webpack_public_path__ + "static/media/navic-drone.a36a4beb.png";